import { render, staticRenderFns } from "./JagfxTruck.vue?vue&type=template&id=f8c3d3e8&"
import script from "./JagfxTruck.vue?vue&type=script&lang=js&"
export * from "./JagfxTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports